var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.12,28.35l-3.41-4a7.44,7.44,0,0,0,0-9.83,7.47,7.47,0,0,0-11.27,9.8,7.46,7.46,0,0,0,5.12,2.55l.53,0a7.38,7.38,0,0,0,4.08-1.23l3.4,3.94a1,1,0,0,0,.76.35,1,1,0,0,0,.66-.24A1,1,0,0,0,29.12,28.35Zm-9.39-3.43a5.46,5.46,0,1,1,4-1.32A5.43,5.43,0,0,1,19.73,24.92Z",
    fill: "#624de3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.636e396e98313709896831abbc4b38e7.svg";
export { ForwardRef as ReactComponent };